import KambiWidgetsApi from './kambi-widgets-API';

const WidgetApi = (function() {
  let instance;

  function init(callbackFunctions, useProdApis, userContext) {
    return new KambiWidgetsApi(callbackFunctions, useProdApis, userContext);
  }

  return {
    get: function() {
      return instance;
    },
    init: function(callbackFunctions, useProdApis, userContext) {
      instance = init(callbackFunctions, useProdApis, userContext);
    }
  };
})();

export default WidgetApi;
